import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutClassWorkplaceRequest, ResponseClassWorkplace } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * クラス名一覧の配列を生成
 * classCategoryNameの重複のない配列
 * @param {*} childClasses
 */
export function getChildClassCategoryNames(childClasses: ResponseClassWorkplace[]) {
  if (!childClasses) return [];
  return Array.from(new Set(childClasses.flatMap((childClass) => childClass.classCategoryName)));
}

/**
 * クラスを更新
 * @param {string} groupId
 * @param {PutClassWorkplaceRequest} payload
 */
export async function updateChildClassWorkplace(classId: string, payload: PutClassWorkplaceRequest) {
  const updatedWorkplaceChildGroup = await shiftServiceRepositories.classWorkplace.update(classId, payload);
  return updatedWorkplaceChildGroup.data;
}

export default {
  getChildClassCategoryNames,
  updateChildClassWorkplace,
};
